import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/perfilFrentista/actions';

import MyForm from './form';

function PerfilFrentista() {
  const redux = useSelector((state) => state.perfilFrentista);

  // Options
  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  // Header tabela
  const header = useMemo(
    () => [
      {
        id: 'nomeperfilfrentista',
        label: t('s.cadastro..usuario.perfil.nomeperfil'),
        filter: { type: 'text' },
      },
      {
        id: 'statusperfilfrentista',
        label: t('s.cadastro..usuario.perfil.statusperfil'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  const fieldlist = [
    'nomeperfilfrentista',
    'param1perfilfrentista',
    'param2perfilfrentista',
    'param3perfilfrentista',
    'param4perfilfrentista',
    'param6perfilfrentista',
    'param8perfilfrentista',
    'param5perfilfrentista',
    'param7perfilfrentista',
    'statusperfilfrentista',
  ];

  const substituirHeader = {
    nomeperfilfrentista: t('s.cadastro..usuario.perfil.nomeperfil'),
    statusperfilfrentista: t('s.cadastro..usuario.perfil.statusperfil'),
    param1perfilfrentista: t('s.cadastro.usuario.liberaafericao'),
    param2perfilfrentista: t('s.cadastro.usuario.recebecombustivel'),
    param3perfilfrentista: t('s.cadastro.usuario.acertaestoque'),
    param4perfilfrentista: t('s.cadastro.usuario.acertaencerrante'),
    param5perfilfrentista: t('s.cadastro.usuario.trocamodooperacional'),
    param6perfilfrentista: t('s.cadastro.usuario.associatransponder'),
    param7perfilfrentista: t('s.cadastro.usuario.liberacaoAbastecimento'),
    param8perfilfrentista: t('s.cadastro.usuario.acessoterminal'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={MyForm}
      keys="idperfilfrentista"
      detach="idperfilfrentista"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'perfilfrentistas',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Perfis de Frentistas',
          substituirValores: {
            statusperfilfrentista: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
            param1perfilfrentista: {
              0: t('s.geral.opcoes.nao'),
              1: t('s.geral.opcoes.sim'),
            },
            param2perfilfrentista: {
              0: t('s.geral.opcoes.nao'),
              1: t('s.geral.opcoes.sim'),
            },
            param3perfilfrentista: {
              0: t('s.geral.opcoes.nao'),
              1: t('s.geral.opcoes.sim'),
            },
            param4perfilfrentista: {
              0: t('s.geral.opcoes.nao'),
              1: t('s.geral.opcoes.sim'),
            },
            param5perfilfrentista: {
              0: t('s.cadastro.usuario.trocamodooperacional.naolibera'),
              1: t(
                's.cadastro.usuario.trocamodooperacional.liberamanualintermitente'
              ),
              2: t(
                's.cadastro.usuario.trocamodooperacional.liberamanualconstante'
              ),
            },
            param6perfilfrentista: {
              0: t('s.geral.opcoes.nao'),
              1: t('s.geral.opcoes.sim'),
            },
            param7perfilfrentista: {
              0: t('s.cadastro.usuario.liberacaoabastecimento.naolibera'),
              1: t(
                's.cadastro.usuario.liberacaoabastecimento.comtranspondercadastrado'
              ),
              2: t(
                's.cadastro.usuario.liberacaoabastecimento.comtranspondernaocadastrado'
              ),
              3: t('s.cadastro.usuario.liberacaoabastecimento.semtransponder'),
              4: t('s.cadastro.usuario.liberacaoabastecimento.liberadigitacao'),
              5: t('s.cadastro.usuario.liberacaoabastecimento.liberadigitacao'),
            },
            param8perfilfrentista: {
              0: t('s.cadastro.usuario.acessoterminal.semacesso'),
              1: t('s.cadastro.usuario.acessoterminal.nivelfrentista'),
              2: t('s.cadastro.usuario.acessoterminal.nivellider'),
              3: t('s.cadastro.usuario.acessoterminal.niveladministrador'),
              4: t(
                's.cadastro.usuario.acessoterminal.niveladministrador.nivelmestre'
              ),
            },
          },
        })
      }
    />
  );
}

export default PerfilFrentista;
